import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import translationEN from '@src/locales/en/trans.json'
import translationTH from '@src/locales/th/trans.json'

import localescareerPageEN from '@src/modules/careerpage/locales/en.json'
import localescareerPageTH from '@src/modules/careerpage/locales/th.json'
import localesContactPageEN from '@src/modules/contactpage/locales/en.json'
import localesContactPageTH from '@src/modules/contactpage/locales/th.json'
import metaDescription from '@src/locales/metaDescription.json'

const resources = {
  en: {
    translation: {
      ...translationEN,
      ...localescareerPageEN,
      ...localesContactPageEN,
      ...metaDescription
    }
  },
  th: {
    translation: {
      ...translationTH,
      ...localescareerPageTH,
      ...localesContactPageTH,
      ...metaDescription
    }
  }
}

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'th'],
    debug: false,
    detection: {
      order: ['path', 'localStorage', 'cookie', 'navigator'], // ลำดับการตรวจจับภาษา
      caches: ['localStorage'] // เก็บค่าภาษาใน localStorage
    },
    interpolation: {
      escapeValue: false // React จะทำ escape เพื่อความปลอดภัยแล้ว
    }
  })

// i18n
//   // load translation using http -> see /public/locales
//   // learn more: https://github.com/i18next/i18next-http-backend
//   // .use(Backend)
//   // detect user language
//   // learn more: https://github.com/i18next/i18next-browser-languageDetector
//   // .use(LanguageDetector)
//   // pass the i18n instance to react-i18next.
//   .use(initReactI18next)
//   // init i18next
//   // for all options read: https://www.i18next.com/overview/configuration-options
//   .init({
//     resources,
//     lng: "en",
//     interpolation: {
//       escapeValue: false // not needed for react as it escapes by default
//     }

//     // react: {
//     //   useSuspense: false
//     // }
//   })

export default i18n
